import type { EffectApiContext } from "@redotech/redo-merchant-app-common/effect-api-client-provider";
import type { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";
import { createAssigneesAdvancedFilter } from "./assignees-filter";
import { ChannelsAdvancedFilter } from "./channels-filter";
import { ClosedAtAdvancedFilter } from "./closed-at-filter";
import { createConversationTagsAdvancedFilter } from "./conversation-tags-filter";
import { CreatedAtAdvancedFilter } from "./created-at-filter";
import { createCustomerTagsAdvancedFilter } from "./customer-tags-filter";
import { LastCustomerMessageAtAdvancedFilter } from "./last-customer-message-at-filter";
import { LastMerchantMessageAtAdvancedFilter } from "./last-merchant-message-at-filter";
import { LastResponseAtAdvancedFilter } from "./last-response-at-filter";
import { createMentionsAdvancedFilter } from "./mentions-filter";
import { ReadStatusAdvancedFilter } from "./read-status-filter";
import { StatusAdvancedFilter } from "./status-filter";
import { WordsAdvancedFilter } from "./words-filter";

export function getConversationAdvancedFilters(
  effectApi?: EffectApiContext,
): AdvancedTableFilter[] {
  return [
    StatusAdvancedFilter,
    ChannelsAdvancedFilter,
    createAssigneesAdvancedFilter(effectApi),
    createConversationTagsAdvancedFilter(effectApi),
    createCustomerTagsAdvancedFilter(effectApi),
    createMentionsAdvancedFilter(effectApi),
    ReadStatusAdvancedFilter,
    WordsAdvancedFilter,
    CreatedAtAdvancedFilter,
    ClosedAtAdvancedFilter,
    LastResponseAtAdvancedFilter,
    LastCustomerMessageAtAdvancedFilter,
    LastMerchantMessageAtAdvancedFilter,
  ];
}
